document.addEventListener('DOMContentLoaded', function () {
    // initHeroSwiper();
    initShopStyles();
  });
 
  /* --- Hero Swiper --- */
  // function initHeroSwiper() {
  //   const MOBILE_BREAKPOINT = 991;
  //   const heroRoot = document.querySelector('.hero-slider');
  //   const heroSliderEl = document.querySelector('.hero-slider .swiper');
  //   const swiperWrapper = heroSliderEl && heroSliderEl.querySelector('.swiper-wrapper');
  //   const promoTemplate = document.getElementById('hero-promo-slides-template');
 
  //   if (!heroSliderEl || !swiperWrapper || !promoTemplate) return;
 
  //   // Guard against this whole setup running more than once for the same
  //   // hero slider (e.g. the script getting included/executed twice on the
  //   // page). Without this, addPromoSlidesToSwiper() below could run from
  //   // two separate closures and append the promo slides twice each time,
  //   // which is exactly what shows up as "promo repeating" even though the
  //   // template only has 2 of them.
  //   if (heroSliderEl.dataset.heroInitialized === '1') return;
  //   heroSliderEl.dataset.heroInitialized = '1';
 
  //   const isIOS = /iP(hone|od|ad)/.test(navigator.userAgent) ||
  //     (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1) ||
  //     (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
 
  //   let heroSwiper = null;
  //   let promoSlidesInSwiper = false;
  //   let lastWidth = window.innerWidth;
  //   let iosTimer = null;
  //   let iosIndex = 0;
  //   let lockedHeroHeight = 0;
  //   let currentMode = null; // 'mobile' | 'desktop' | null
 
  //   function isMobileView() {
  //     return Math.min(window.innerWidth, document.documentElement.clientWidth) <= MOBILE_BREAKPOINT;
  //   }
 
  //   // Preload promo slide images as soon as possible (regardless of device),
  //   // so there is no image pop-in delay the first time a promo slide is shown.
  //   function preloadPromoImages() {
  //     var frag = promoTemplate.content;
  //     if (!frag) return;
 
  //     frag.querySelectorAll('img[src]').forEach(function (img) {
  //       var preload = new Image();
  //       preload.src = img.currentSrc || img.getAttribute('src');
  //     });
  //     frag.querySelectorAll('img[data-src]').forEach(function (img) {
  //       var preload = new Image();
  //       preload.src = img.getAttribute('data-src');
  //     });
  //     frag.querySelectorAll('[data-image]').forEach(function (el) {
  //       var preload = new Image();
  //       preload.src = el.getAttribute('data-image');
  //     });
  //     frag.querySelectorAll('source[srcset]').forEach(function (source) {
  //       var preload = new Image();
  //       preload.src = source.getAttribute('srcset').split(',')[0].trim().split(' ')[0];
  //     });
  //   }
  //   preloadPromoImages();
 
  //   function addPromoSlidesToSwiper() {
  //     if (promoSlidesInSwiper) return;
  //     // Check the actual DOM too, not just the in-memory flag -- if promo
  //     // slides are already sitting in the wrapper (from a previous run, or
  //     // because they were server-rendered), don't clone another copy of
  //     // the template on top of them.
  //     if (swiperWrapper.querySelector('.hero-slide--mobile-only')) {
  //       promoSlidesInSwiper = true;
  //       return;
  //     }
  //     swiperWrapper.appendChild(promoTemplate.content.cloneNode(true));
  //     promoSlidesInSwiper = true;
  //   }
 
  //   function removePromoSlidesFromSwiper() {
  //     if (!promoSlidesInSwiper) return;
  //     swiperWrapper.querySelectorAll('.hero-slide--mobile-only').forEach(function (slide) {
  //       slide.remove();
  //     });
  //     promoSlidesInSwiper = false;
  //   }
 
  //   function getSlides() {
  //     return Array.prototype.slice.call(swiperWrapper.querySelectorAll('.swiper-slide'));
  //   }
 
  //   function getLockedHeroHeight() {
  //     if (lockedHeroHeight) return lockedHeroHeight;
  //     var screenH = screen.height || window.innerHeight || 700;
  //     lockedHeroHeight = Math.max(460, Math.round(screenH * 0.55));
  //     return lockedHeroHeight;
  //   }
 
  //   function applyHeroHeight() {
  //     var h = getLockedHeroHeight() + 'px';
  //     if (heroRoot) {
  //       heroRoot.style.setProperty('height', h, 'important');
  //       heroRoot.style.setProperty('min-height', h, 'important');
  //     }
  //     heroSliderEl.style.setProperty('height', h, 'important');
  //     heroSliderEl.style.setProperty('min-height', h, 'important');
  //   }
 
  //   function injectIOSHeroCSS() {
  //     if (document.getElementById('ios-hero-fix-css')) return;
  //     var style = document.createElement('style');
  //     style.id = 'ios-hero-fix-css';
  //     style.textContent = [
  //       '.hero-slider.ios-hero-fix {',
  //       '  position: relative !important;',
  //       '  overflow: hidden !important;',
  //       '  width: 100% !important;',
  //       '}',
  //       '.hero-slider.ios-hero-fix .swiper,',
  //       '.hero-slider.ios-hero-fix .swiper-wrapper {',
  //       '  display: block !important;',
  //       '  position: relative !important;',
  //       '  width: 100% !important;',
  //       '  height: 100% !important;',
  //       '  min-height: 0 !important;',
  //       '  max-height: none !important;',
  //       '  transform: none !important;',
  //       '  overflow: hidden !important;',
  //       '}',
  //       '.hero-slider.ios-hero-fix .swiper-slide {',
  //       '  display: block !important;',
  //       '  position: absolute !important;',
  //       '  inset: 0 !important;',
  //       '  width: 100% !important;',
  //       '  height: 100% !important;',
  //       '  opacity: 0 !important;',
  //       '  visibility: hidden !important;',
  //       '  pointer-events: none !important;',
  //       '  transform: none !important;',
  //       '  left: auto !important;',
  //       '  top: auto !important;',
  //       '  overflow: hidden !important;',
  //       '  transition: opacity 500ms ease !important;',
  //       '  z-index: 1;',
  //       '}',
  //       '.hero-slider.ios-hero-fix .swiper-slide.ios-active {',
  //       '  opacity: 1 !important;',
  //       '  visibility: visible !important;',
  //       '  pointer-events: auto !important;',
  //       '  z-index: 2;',
  //       '}',
  //       '.hero-slider.ios-hero-fix .swiper-slide img,',
  //       '.hero-slider.ios-hero-fix .swiper-slide video,',
  //       '.hero-slider.ios-hero-fix .swiper-slide picture {',
  //       '  position: absolute !important;',
  //       '  inset: 0 !important;',
  //       '  width: 100% !important;',
  //       '  height: 100% !important;',
  //       '  max-height: none !important;',
  //       '  min-height: 0 !important;',
  //       '  object-fit: cover !important;',
  //       '  object-position: center !important;',
  //       '}',
  //       '.hero-slider.ios-hero-fix .hero-slider__nav,',
  //       '.hero-slider.ios-hero-fix .hero-slider__nav-btn--prev,',
  //       '.hero-slider.ios-hero-fix .hero-slider__nav-btn--next {',
  //       '  position: absolute !important;',
  //       '  z-index: 6;',
  //       '  bottom: 16px !important;',
  //       '  top: auto !important;',
  //       '}'
  //     ].join('');
  //     document.head.appendChild(style);
  //   }
 
  //   function showIOSSlide(index) {
  //     var slides = getSlides();
  //     if (!slides.length) return;
  //     iosIndex = (index + slides.length) % slides.length;
  //     slides.forEach(function (slide, i) {
  //       slide.classList.toggle('ios-active', i === iosIndex);
  //     });
  //   }
 
  //   function stopIOSHero() {
  //     if (iosTimer) {
  //       clearInterval(iosTimer);
  //       iosTimer = null;
  //     }
  //   }
 
  //   function startIOSHero() {
  //     injectIOSHeroCSS();
  //     if (heroRoot) heroRoot.classList.add('ios-hero-fix');
  //     heroSliderEl.classList.add('ios-hero-fix');
 
  //     addPromoSlidesToSwiper();
  //     applyHeroHeight();
  //     showIOSSlide(0);
 
  //     var nextBtn = document.querySelector('.hero-slider__nav-btn--next');
  //     var prevBtn = document.querySelector('.hero-slider__nav-btn--prev');
 
  //     function restartTimer() {
  //       stopIOSHero();
  //       iosTimer = setInterval(function () {
  //         showIOSSlide(iosIndex + 1);
  //       }, 5000);
  //     }
 
  //     if (nextBtn && !nextBtn.dataset.iosBound) {
  //       nextBtn.dataset.iosBound = '1';
  //       nextBtn.addEventListener('click', function (e) {
  //         e.preventDefault();
  //         showIOSSlide(iosIndex + 1);
  //         restartTimer();
  //       });
  //     }
 
  //     if (prevBtn && !prevBtn.dataset.iosBound) {
  //       prevBtn.dataset.iosBound = '1';
  //       prevBtn.addEventListener('click', function (e) {
  //         e.preventDefault();
  //         showIOSSlide(iosIndex - 1);
  //         restartTimer();
  //       });
  //     }
 
  //     restartTimer();
  //   }
 
  //   function destroySwiper() {
  //     if (heroSwiper) {
  //       heroSwiper.destroy(true, true);
  //       heroSwiper = null;
  //     }
  //   }
 
  //   function initDesktopSwiper() {
  //     destroySwiper();
  //     stopIOSHero();
  //     lockedHeroHeight = 0;
  //     if (heroRoot) {
  //       heroRoot.classList.remove('ios-hero-fix');
  //       heroRoot.style.removeProperty('height');
  //       heroRoot.style.removeProperty('min-height');
  //     }
  //     heroSliderEl.classList.remove('ios-hero-fix');
  //     heroSliderEl.style.removeProperty('height');
  //     heroSliderEl.style.removeProperty('min-height');
  //     getSlides().forEach(function (slide) {
  //       slide.classList.remove('ios-active');
  //     });
 
  //     removePromoSlidesFromSwiper();
 
  //     var slideCount = getSlides().length;
 
  //     heroSwiper = new Swiper(heroSliderEl, {
  //       loop: slideCount > 1,
  //       speed: 600,
  //       autoplay: {
  //         delay: 5000,
  //         disableOnInteraction: false,
  //       },
  //       navigation: {
  //         nextEl: '.hero-slider__nav-btn--next',
  //         prevEl: '.hero-slider__nav-btn--prev',
  //       },
  //       effect: 'fade',
  //       fadeEffect: {
  //         crossFade: true,
  //       },
  //       updateOnWindowResize: false,
  //     });
  //   }
 
  //   function initByDevice() {
  //     var targetMode = (isIOS || isMobileView()) ? 'mobile' : 'desktop';
 
  //     // If we're already running in this mode, don't tear the slider down
  //     // and reset it to slide 0 just because a resize event fired (mobile
  //     // address-bar show/hide, minor viewport jitter, etc). That reset was
  //     // what caused slides -- including the promo slide -- to get cut off
  //     // early ("jhatka") instead of running their full 5s autoplay delay.
  //     if (targetMode === currentMode) {
  //       if (targetMode === 'mobile') applyHeroHeight();
  //       return;
  //     }
 
  //     currentMode = targetMode;
 
  //     if (targetMode === 'mobile') {
  //       destroySwiper();
  //       startIOSHero();
  //       return;
  //     }
 
  //     initDesktopSwiper();
  //   }
 
  //   initByDevice();
 
  //   var resizeTimer;
  //   window.addEventListener('resize', function () {
  //     var width = window.innerWidth;
  //     if (width === lastWidth) return;
  //     lastWidth = width;
  //     clearTimeout(resizeTimer);
  //     resizeTimer = setTimeout(initByDevice, 300);
  //   });
  // }
 
 
 
  /* --- Shop Styles Interactive Nav + Autoplay --- */
  function initShopStyles() {
    const section = document.querySelector('.shop-styles');
    const nav = document.querySelector('.shop-styles__nav');
    const image = document.querySelector('.shop-styles__image');
    const items = Array.from(document.querySelectorAll('.shop-styles__nav-item'));
    const loadMoreBtn = document.querySelector('.shop-styles__load-more');
    const mobileGrid = document.querySelector('.shop-styles__mobile-grid');
 
    if (items.length && nav && image && section) {
      let currentIndex = items.findIndex(function (item) {
        return item.classList.contains('is-active');
      });
      if (currentIndex < 0) currentIndex = 0;
 
      let isAnimating = false;
      let autoplayTimer = null;
      const AUTOPLAY_DELAY = 3500;
 
      items.forEach(function (item) {
        const preload = new Image();
        preload.src = item.dataset.image;
      });
 
      function setActiveItem(activeItem, updateIndex) {
        if (typeof updateIndex === 'undefined') updateIndex = true;
 
        items.forEach(function (item) {
          item.classList.remove('is-active');
        });
        activeItem.classList.add('is-active');
 
        if (updateIndex) {
          currentIndex = items.indexOf(activeItem);
        }
 
        if (isAnimating) return;
        isAnimating = true;
 
        const newSrc = activeItem.dataset.image;
        const newLabel = activeItem.dataset.label;
 
        image.style.opacity = '0';
 
        setTimeout(function () {
          image.src = newSrc;
          image.alt = newLabel || activeItem.querySelector('.shop-styles__nav-text').textContent.trim();
          image.style.opacity = '1';
          isAnimating = false;
        }, 350);
      }
 
      function goToIndex(index) {
        setActiveItem(items[index], false);
        currentIndex = index;
      }
 
      function startAutoplay() {
        stopAutoplay();
        autoplayTimer = setInterval(function () {
          currentIndex = (currentIndex + 1) % items.length;
          goToIndex(currentIndex);
        }, AUTOPLAY_DELAY);
      }
 
      function stopAutoplay() {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
 
      items.forEach(function (item) {
        item.addEventListener('mouseenter', function () {
          stopAutoplay();
          setActiveItem(item);
        });
 
        item.addEventListener('focus', function () {
          stopAutoplay();
          setActiveItem(item);
        });
      });
 
      section.addEventListener('mouseleave', function () {
        startAutoplay();
      });
 
      startAutoplay();
    }
 
    if (loadMoreBtn && mobileGrid) {
      loadMoreBtn.addEventListener('click', function () {
        mobileGrid.classList.add('is-expanded');
        loadMoreBtn.classList.add('is-hidden');
        loadMoreBtn.setAttribute('aria-expanded', 'true');
      });
    }
  }
 
 
 
    //   explore section
    const tabs = document.querySelectorAll(".explore-tab li");
    const tabBoxes = document.querySelectorAll(".explore-tab-box");
    const tabList = document.querySelector(".explore-tab");
    if (tabs.length) {
      tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => {
          tabs.forEach((t) => t.classList.remove("active"));
          tabBoxes.forEach((b) => b.classList.remove("active"));
 
          tab.classList.add("active");
          tabBoxes[index].classList.add("active");
 
          const tabWidth = tab.offsetWidth;
          const tabLeft = tab.offsetLeft;
          const listWidth = tabList.offsetWidth;
          const scrollTo = tabLeft - listWidth / 2 + tabWidth / 2;
          tabList.scrollTo({ left: scrollTo, behavior: "smooth" });
        });
      });
    }
 
  (function () {
    var trigger = document.querySelector('.available-coupons');
    var popup = document.getElementById('couponPopup');
    var closeBtn = document.getElementById('couponPopupClose');
    var overlay, innerOverlay;
 
    if (!trigger || !popup) return;
 
    function outsideClick(e) {
      if (!popup.contains(e.target) && !trigger.contains(e.target)) {
        closePopup();
      }
    }
 
    function openPopup() {
      if (overlay) return;
 
      overlay = document.createElement('div');
      overlay.className = 'coupon-popup-overlay';
      document.body.appendChild(overlay);
 
      innerOverlay = document.createElement('div');
      innerOverlay.className = 'coupon-popup-inner-overlay';
      popup.before(innerOverlay);
 
      document.body.classList.add('coupon-popup-lock');
      document.body.classList.add('coupon-popup-active');
 
      document.body.style.paddingRight =
        (window.innerWidth - document.documentElement.clientWidth) + 'px';
 
      popup.classList.add('coupon-popup--open');
 
      setTimeout(function () {
        document.addEventListener('click', outsideClick);
      }, 0);
    }
 
    function closePopup() {
      if (!overlay) return;
 
      popup.classList.remove('coupon-popup--open');
 
      document.body.classList.remove('coupon-popup-lock');
      document.body.classList.remove('coupon-popup-active');
      document.body.style.paddingRight = '';
 
      document.removeEventListener('click', outsideClick);
 
      overlay.remove();
      innerOverlay.remove();
 
      overlay = null;
      innerOverlay = null;
    }
 
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      openPopup();
    });
 
    if (closeBtn) {
      closeBtn.addEventListener('click', closePopup);
    }
 
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closePopup();
      }
    });
 
    popup.querySelectorAll('.coupon-popup__apply').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = document.getElementById('cart-discount');
 
        if (input) {
          input.value = btn.getAttribute('data-coupon');
        }
 
        closePopup();
      });
    });
 
  })();
  //   new Swiper(".recommendationSwiper", {
 
  //     slidesPerView:1.2,
  //     spaceBetween:16,
 
  //     navigation:{
  //         nextEl:".recommendation-next",
  //         prevEl:".recommendation-prev",
  //     },
 
  //     breakpoints:{
  //         576:{
  //             slidesPerView:2
  //         },
  //         768:{
  //             slidesPerView:2.2
  //         },
  //         1024:{
  //             slidesPerView:2.5
  //         },
  //         1280:{
  //             slidesPerView:3
  //         }
  //     }
 
  // });